'use strict';

var commonAttrHelper = require('./utilHelper');

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 * @param {string} attrExtension - customizable data-attr-value extension
 */
function updateAttrs(attrs, $productContainer, msgs, attrExtension) {
    // Currently, the only attribute type that has image swatches is Color.
    commonAttrHelper.updateAttributes(attrs, $productContainer, msgs, attrExtension, 'normal');
}

module.exports = {
    updateAttrs: updateAttrs
};
